import React, { useEffect, useState } from "react";
import { Switch, List, Image, message, Skeleton, Button, Modal, Space } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { fetchSponsors, updateSponsorStatus, deleteSponsor } from "../../../../api/sponsor";

const SponsorList = () => {
  const [sponsors, setSponsors] = useState([]);
  const [loading, setLoading] = useState(false);
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [sponsorToDelete, setSponsorToDelete] = useState(null);

  const loadSponsors = async () => {
    setLoading(true);
    try {
      const data = await fetchSponsors();
      if (data) {
        setSponsors(data);
      }
    } catch (error) {
      console.error("Error loading sponsors:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadSponsors();
  }, []);

  const handleToggle = async (id, checked) => {
    try {
      const response = await updateSponsorStatus(id, checked);
      if (response) {
        setSponsors((prev) =>
          prev.map((s) => (s._id === id ? { ...s, isActive: checked } : s))
        );
        message.success("Status updated successfully");
      }
    } catch (error) {
      console.error("Error updating status:", error);
      message.error("Failed to update status");
    }
  };

  const showDeleteModal = (sponsor) => {
    setSponsorToDelete(sponsor);
    setDeleteModalVisible(true);
  };

  const handleDelete = async () => {
    if (!sponsorToDelete) return;
    
    try {
      const response = await deleteSponsor(sponsorToDelete._id);
      if (response) {
        setSponsors((prev) => prev.filter((s) => s._id !== sponsorToDelete._id));
        message.success("Sponsor deleted successfully");
        setDeleteModalVisible(false);
        setSponsorToDelete(null);
      }
    } catch (error) {
      console.error("Error deleting sponsor:", error);
      message.error("Failed to delete sponsor");
    }
  };

  const handleCancelDelete = () => {
    setDeleteModalVisible(false);
    setSponsorToDelete(null);
  };

  if (loading) {
    return <Skeleton active />;
  }

  return (
    <div>
      <h3 className="text-lg font-semibold mb-4">Sponsors List</h3>
      <List
        dataSource={sponsors}
        renderItem={(item) => (
          <List.Item
            actions={[
              <Space key="actions">
                <Button
                  type="text"
                  danger
                  icon={<DeleteOutlined />}
                  onClick={() => showDeleteModal(item)}
                  title="Delete Sponsor"
                />
                <Switch
                  checked={item.isActive}
                  onChange={(checked) => handleToggle(item._id, checked)}
                  checkedChildren="Active"
                  unCheckedChildren="Inactive"
                />
              </Space>,
            ]}
          >
            <List.Item.Meta
              avatar={
                <Image
                  width={100}
                  height={60}
                  src={item.imageUrl}
                  alt="sponsor"
                  style={{ objectFit: "cover" }}
                />
              }
           />
          </List.Item>
        )}
      />

      <Modal
        title="Confirm Delete"
        open={deleteModalVisible}
        onOk={handleDelete}
        onCancel={handleCancelDelete}
        okText="Yes"
        cancelText="No"
        okButtonProps={{ danger: true }}
      >
        <p>
          Are you sure you want to delete this sponsor?
        </p>
        <p className="text-gray-500 text-sm mt-2">
          This action cannot be undone.
        </p>
      </Modal>
    </div>
  );
};

export default SponsorList;